/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');

window.Popper = require('@popperjs/core').default;





require('jquery-ui/dist/jquery-ui.js');
window.colorbox = require('jquery-colorbox');


import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
window.ChartDataLabels = ChartDataLabels;
window.Chart = Chart;



window.select2=require('select2');

require('../plugins');
require('leaflet/dist/leaflet.js');
require('leaflet-polylinedecorator/dist/leaflet.polylineDecorator.js');

window.Push = require('push.js/bin/push.min.js');

/**
 * Vue 3 Example (commented out - uncomment if needed)
 *
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// import { createApp } from 'vue';
// import ExampleComponent from './components/ExampleComponent.vue';
//
// const app = createApp({});
// app.component('example-component', ExampleComponent);
//
// // Auto-register all .vue components (optional)
// // const files = import.meta.glob('./components/*.vue', { eager: true });
// // Object.entries(files).forEach(([path, module]) => {
// //     const name = path.split('/').pop().replace('.vue', '');
// //     app.component(name, module.default);
// // });
//
// app.mount('#app');
